import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'
import studentReducer from './slices/studentSlice'
import teacherReducer from './slices/teacherSlice'
import lessonReducer from './slices/lessonSlice'
import parentReducer from './slices/parent.slice'
import adaptiveReducer from './slices/adaptive.slice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    students: studentReducer,
    teachers: teacherReducer,
    lessons: lessonReducer,
    parent: parentReducer,
    adaptive: adaptiveReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch